export default "__VITE_ASSET__CBIk1RCp__"